import { render } from "./MobileAppLinkModal.vue?vue&type=template&id=4de87404&ts=true"
import script from "./MobileAppLinkModal.vue?vue&type=script&lang=ts"
export * from "./MobileAppLinkModal.vue?vue&type=script&lang=ts"

import "./MobileAppLinkModal.vue?vue&type=style&index=0&id=4de87404&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__